module.exports = {

  // User Channels
  "ubxc": {
    "title": "Web Chat",
    "description": "Visitors to your website can chat with your customer success team directly from the browser.",
    "steps": [
      {
        "title": "Activate web chat",
        "view_text": "Web chat already enabled",
        "save": "create"
      },
      {
        "title": "Embed code snippet",
        "text": "Copy/Paste this<br /><br />",
        "view_text": ""
      }
    ]
  },
  "uchat": {
    "title": "User CLI Chat",
    "description": "Connecting to User CLI Chat is so easy etc etc",
    "steps": [
      {
        "title": "Set Chat Channel Name",
        "text": "Enter your chat channel name",
        "action": "edit-param",
        "label": "Id",
        "required": true,
        "value": "channel",
        "save": "create"
      },
      {
        "title": "Set channel title",
        "text": "Enter your channel title",
        "action": "edit-title",
        "value": "title",
        "save": "edit"
      }
    ]
  },
  "uemail": {
    "title": "Email",
    "description": "Users can move chat to email.",
    "steps": [
      {
        "title": "Activate email",
        "view_text": "Email already enabled",
        "save": "create"
      }
    ]
  },
  "ufbm": {
    "title": "Facebook",
    "description": "Chat with over 1.2 billion users on Facebook Messenger",
    "steps": [
      {
        "title": "Facebook Pages",
        "text": "FB Messenger must be connected to a Page. Retrieve the list of Pages that you manage.",
        "view_text": "Facebook Messenger already connected"
      },
      {
        "title": "Enable Messenger for Page",
        "text": "Select FB page that Messenger will be connected to",
        "view_text": "",
        "save": "create"
      }
    ]
  },
  "ukik": {
    "title": "Kik",
    "description": "You can have direct access to more than 300 million registered users on Kik",
    "steps": [
      {
        "title": "Create a Bot",
        "text": "Follow the instructions at <a href=\"https://dev.kik.com\" target=\"_new\">dev.kik.com</a> to create a bot and get its username and API key.",
        "view_text": "Bot already created"
      },
      {
        "title": "Bot username",
        "text": "Enter username for your bot",
        "action": "edit-param",
        "label": "username",
        "required": true,
        "value": "_id_address"
      },
      {
        "title": "Bot API key",
        "text": "Enter API key for your bot",
        "action": "edit-param",
        "label": "apikey",
        "required": true,
        "value": "api_key",
        "save": "create"
      },
      //{
      //  "title": "Channel title",
      //  "text": "Enter your channel title",
      //  "action": "edit-title",
      //  "value": "title",
      //  "save": "edit"
      //}
    ]
  },
  "uline": {
    "title": "LINE",
    "description": "Chat with over 800 million LINE users",
    "steps": [
      {
        "title": "Channel ID",
        "text": "Enter your Channel ID",
        "action": "edit-param",
        "label": "Id",
        "required": true,
        "value": "channel_id"
      },
      {
        "title": "API key",
        "text": "Enter your access token",
        "action": "edit-param",
        "required": true,
        "value": "token",
        "save": "create"
      },
      //{
      //  "title": "Channel title",
      //  "text": "Enter your channel title",
      //  "action": "edit-title",
      //  "value": "title",
      //  "save": "edit"
      //}
    ]
  },
  "usms": {
    "title": "SMS",
    "description": "Any user can contact your customer service directly from a mobile phone",
    "steps": [
      {
        "title": "Find phone number (US only)",
        "text": "Select Toll Free or enter state / area code to search for Local numbers",
        "view_text": "SMS already configured"
      },
      {
        "title": "Enable SMS",
        "text": "Select phone number",
        "view_text": "",
        "save": "create"
      }
    ]
  },
  "uviber": {
    "title": "Viber",
    "description": "Connect to 800 million registered users on Viber",
    "steps": [
      {
        "title": "Public account name",
        "text": "Enter account name",
        "action": "edit-param",
        "label": "Id",
        "required": true,
        "value": "account_name"
      },
      {
        "title": "Auth token",
        "text": "Enter authentication token / app key",
        "action": "edit-param",
        "required": true,
        "value": "token",
        "save": "create"
      },
      //{
      //  "title": "Channel title",
      //  "text": "Enter your channel title",
      //  "action": "edit-title",
      //  "value": "title",
      //  "save": "edit"
      //}
    ]
  },
  "utlg": {
    "title": "Telegram",
    "description": "Your customers can contact you on Telegram",
    "steps": [
      {
        "title": "Create a Bot",
        "text": "Sign into Telegram and chat with <a href=\"https://t.me/BotFather\" target=\"_new\">BotFather</a> to create a bot",
        "view_text": "Telegram bot already created"
      },
      {
        "title": "Bot token",
        "text": "Copy bot token from Telegram and paste it below",
        "image": "utlg-step-2.png",
        "action": "edit-param",
        "required": true,
        "value": "token",
        "save": "create"
      }
    ]
  },
  "utweet": {
    "title": "Twitter",
    "description": "Public tweets from users",
    "steps": [
      {
        "title": "Set Screen Name",
        "action": "edit-param",
        "label": "Screen Name",
        "required": true,
        "value": "screen_name"
      },
      {
        "title": "Access Token",
        "action": "edit-param",
        "required": true,
        "value": "access_token"
      },
      {
        "title": "Access Token Secret",
        "action": "edit-param",
        "required": true,
        "value": "access_token_secret"
      },
      {
        "title": "Track",
        "text": "Enter the keywords to track",
        "action": "edit-param",
        "required": true,
        "value": "track",
        "save": "create"
      },
      {
        "title": "Set channel title",
        "text": "Enter your channel title",
        "action": "edit-title",
        "value": "title",
        "save": "edit"
      }
    ]
  },
  "utwitdm": {
    "title": "Twitter DM",
    "description": "Direct messages from users",
    "steps": [
      {
        "title": "Set Screen Name",
        "action": "edit-param",
        "label": "Screen Name",
        "required": true,
        "value": "screen_name"
      },
      {
        "title": "Access Token",
        "action": "edit-param",
        "required": true,
        "value": "access_token"
      },
      {
        "title": "Access Token Secret",
        "action": "edit-param",
        "required": true,
        "value": "access_token_secret",
        "save": "create"
      },
      {
        "title": "Set channel title",
        "text": "Enter your channel title",
        "action": "edit-title",
        "value": "title",
        "save": "edit"
      }
    ]
  },
  "uwechat": {
    "title": "WeChat",
    "description": "WeChat has over 900 million monthly active users",
    "steps": [
      {
        "title": "App ID",
        "text": "Enter App ID",
        "action": "edit-param",
        "label": "Id",
        "required": true,
        "value": "appid"
      },
      {
        "title": "App Secret",
        "text": "Enter App Secret",
        "action": "edit-param",
        "required": true,
        "value": "secret",
        "save": "create"
      },
      {
        "title": "Get Webhook URL",
        "text": "Copy/Paste this<br /><br />",
        "action": "show-prop",
        "value": "webhook.url"
      },
      //{
      //  "title": "Set channel title",
      //  "text": "Enter your channel title",
      //  "action": "edit-title",
      //  "value": "title",
      //  "save": "edit"
      //}
    ]
  },


  // Agent Channels
  "achat": {
    "title": "Agent CLI Chat",
    "description": "Connecting to Agent CLI Chat is so easy etc etc",
    "steps": [
      {
        "title": "Set Chat Channel Name",
        "text": "Enter your chat channel name",
        "action": "edit-param",
        "label": "Id",
        "required": true,
        "value": "channel",
        "save": "create"
      },
      {
        "title": "Set channel title",
        "text": "Enter your channel title",
        "action": "edit-title",
        "value": "title",
        "save": "edit"
      }
    ]
  },
  "ahelpscout": {
    "title": "Help Scout",
    "description": "Connecting to Help Scout is so easy etc etc",
    "steps": [
      {
        "title": "Set Mailbox Email",
        "text": "Enter your mailbox name",
        "action": "edit-param",
        "label": "Id",
        "required": true,
        "value": "email"
      },
      {
        "title": "Set api key",
        "text": "Enter your apikey",
        "action": "edit-param",
        "required": true,
        "value": "apikey",
        "save": "create"
      },
      {
        "title": "Set channel title",
        "text": "Enter your channel title",
        "action": "edit-title",
        "value": "title",
        "save": "edit"
      }
    ]
  },
  "aslack": {
    "title": "Slack",
    "description": "Connecting to Slack is so easy etc etc",
    "steps": [
      {
        "title": "Login to Slack",
        "text": "Sign into the Slack",
        "view_text": "Already connected to Slack"
      },
      {
        "title": "All Done!",
        "save": "create"
      }
    ]
  },
  "agroove": {
    "title": "Groove",
    "description": "Simple Help Desk Software",
    "steps": [
      {
        "title": "Groove agent email",
        "action": "edit-param",
        "label": "Groove id",
        "required": true,
        "value": "email"
      },
      {
        "title": "Private Token",
        "action": "edit-param",
        "required": true,
        "value": "token",
        "save": "create"
      },
      {
        "title": "Set channel title",
        "text": "Enter your channel title",
        "action": "edit-title",
        "value": "title",
        "save": "edit"
      }
    ]
  },
  "azendesk": {
    "title": "Zendesk",
    "description": "Use Zendesk Support tickets to manage customer conversations from any channel",
    "steps": [
      {
        "title": "Zendesk API access",
        "text": "In Zendesk Admin page go to 'Channels' section and select 'API'. Make sure 'Token Access' is enabled, then create and copy a new API Token",
        "view_text": "Zendesk integration already activated",
        "image": "azendesk-step-1.png",
      },
      {
        "title": "API token",
        "text": "Paste your API token below",
        "action": "edit-param",
        "required": true,
        "value": "token",
      },
      {
        "title": "Zendesk account",
        "text": "Enter subdomain of your Zendesk account - https://<u>subdomain</u>.zendesk.com",
        "action": "edit-param",
        "label": "subdomain",
        "required": true,
        "value": "subdomain"
      },
      {
        "title": "Agent email",
        "text": "Enter email of the agent on whose behalf AssistHub will access Zendesk API",
        "action": "edit-param",
        "required": true,
        "value": "email",
        "save": "create"
      },
      //{
      //  "title": "Set channel title",
      //  "text": "Enter your channel title",
      //  "action": "edit-title",
      //  "value": "title",
      //  "save": "edit"
      //}
    ]
  },
  "aemail": {
    "title": "Email",
    "description": "",
    "steps": [
      {
        "title": "Set your email",
        "text": "Enter your email address",
        "action": "edit-param",
        "label": "email",
        "required": true,
        "value": "email",
      },
      {
        "title": "Set your agent email signature",
        "text": "Enter your email signature",
        "action": "edit-param",
        "label": "signature",
        "value": "signature",
        "save": "create"
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/containers/ChannelConfigSteps.js